import { render, staticRenderFns } from "./MicrositesPreview.vue?vue&type=template&id=470a4d88&scoped=true&"
import script from "./MicrositesPreview.vue?vue&type=script&lang=ts&"
export * from "./MicrositesPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MicrositesPreview.vue?vue&type=style&index=0&id=470a4d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a4d88",
  null
  
)

export default component.exports